module.exports = __webpack_public_path__ + "img/img_card02.26e4a0cf.png";